import { render } from "./TechnicalSupport.vue?vue&type=template&id=5e7a38b0&scoped=true"
import script from "./TechnicalSupport.vue?vue&type=script&lang=js"
export * from "./TechnicalSupport.vue?vue&type=script&lang=js"

import "./TechnicalSupport.vue?vue&type=style&index=0&id=5e7a38b0&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e7a38b0"]])

export default __exports__